// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1LrFA","inner":"Form_inner__1Wu4V","range":"Form_range__17jar","name":"Form_name__3vTns","actions":"Form_actions__3Aa1w"};